var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleVk22X22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3931 14.3002C8.38648 14.3002 6.67155 11.8227 6.6001 7.7002H8.10616C8.15563 10.726 9.26593 12.0077 10.1454 12.272V7.7002H11.5635V10.3098C12.432 10.1975 13.3444 9.0083 13.6522 7.7002H15.0703C14.9543 8.37862 14.7231 9.02097 14.3911 9.58709C14.0592 10.1532 13.6336 10.6309 13.141 10.9903C13.6908 11.3187 14.1765 11.7835 14.5659 12.354C14.9553 12.9246 15.2396 13.5879 15.4001 14.3002H13.8391C13.695 13.6815 13.4023 13.1277 12.9975 12.7081C12.5927 12.2885 12.0938 12.0219 11.5635 11.9416V14.3002H11.3931Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleVk22X22);
export default __webpack_public_path__ + "static/media/circle-vk-22x22.61afd781c5cf2a5ef509f111925c3af5.svg";
export { ForwardRef as ReactComponent };